import React from 'react';
import ApartmentList from './ApartmentList';

const SearchApartments: React.FC = () => {
  return <ApartmentList />;
};

export default SearchApartments; 